
import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import API from '@iso/lib/helpers/api';
import actions from './actions';
import { createNotification } from '../../components/Notification';


export function* listTransactionRequest() {
  yield takeEvery('LIST_TRANSACTIONS_REQUEST', function*({ token, environment }) {
    const transactionsCall = yield call(API.listTransactions, token, environment);
      if (transactionsCall.status === 200) {
        yield put({
          type: actions.LIST_TRANSACTIONS_SUCCESS,
          payload: transactionsCall.data.data.reverse(),
        });
      } else {
        yield put({ type: actions.LIST_TRANSACTIONS_ERROR, error: transactionsCall.response.data});
      }
  });
}

export function* listTransactionsError() {
  yield takeEvery(actions.LIST_TRANSACTIONS_ERROR, function*(data) {
    yield createNotification('error', 'Fail.', 'We are having some throubles to load your transactions. Try again later.')
  });
}


export function* listBillsRequest() {
  yield takeEvery('LIST_BILLS_REQUEST', function*({ token }) {
    const fetchBills = yield call(API.listUserBills, token);
      if (fetchBills.status === 200) {
        yield put({
          type: actions.LIST_BILLS_SUCCESS,
          payload: fetchBills.data.data.reverse(),
        });
      } else {
        yield put({ type: actions.LIST_BILLS_ERROR, error: fetchBills.response.data});
      }
  });
}

export function* listBillsError() {
  yield takeEvery(actions.LIST_BILLS_ERROR, function*(data) {
    yield createNotification('error', 'Fail.', 'We are facing some throubles to load your bills. Try again later.')
  });
}
export default function* rootSaga() {
  yield all([
    fork(listTransactionRequest),
    fork(listTransactionsError),
    fork(listBillsRequest),
    fork(listBillsError),

  ]);
}